/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuditLogRepresentationFromJSON, AuditLogRepresentationToJSON, } from './';
export function AuditLogRepresentationPageFromJSON(json) {
    return AuditLogRepresentationPageFromJSONTyped(json, false);
}
export function AuditLogRepresentationPageFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        content: json['content'].map(AuditLogRepresentationFromJSON),
        index: json['index'],
        size: json['size'],
        totalElementCount: json['totalElementCount'],
        totalPageCount: json['totalPageCount'],
    };
}
export function AuditLogRepresentationPageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        content: value.content.map(AuditLogRepresentationToJSON),
        index: value.index,
        size: value.size,
        totalElementCount: value.totalElementCount,
        totalPageCount: value.totalPageCount,
    };
}
